import React from 'react';

const About = () => {
	return (
		<div className="background" id="about">
			<div className="section-wrapper">
				<h2>About me</h2>
				<p className="about-lead">
					I work across product design and frontend development. My work combines UX, UI, accessibility, design systems, and implementation, allowing me to take a solution from an early concept all the way to production.
				</p>
				<p>
					For me, design and development aren't always separate phases of a project, as I am often the one implementing the design. The solution continues to evolve while I'm building, as implementation raises questions, reveals new possibilities and sometimes changes the solution. I naturally think in systems rather than individual features. While working, I strive to create reusable patterns, strengthen the design system, and make future work easier for the team.
				</p>
				<p>I don't think interfaces should try to influence people through dark patterns or unnecessary friction. I also don't believe enterprise software should hide complexity just for the sake of appearing simpler. Good design is about organizing complexity, explaining it when needed, and helping people work with it confidently.</p>
				<p>I am curious by nature and like understanding how things work, why they're designed the way they are, and whether they could be improved. I regularly learn about topics such as product design, frontend development, AI, and accessibility.</p>
				<p>Outside work you'll usually find me running, gardening, or building something creative with my hands.</p>
			</div>
		</div>
	);
};

export default About;
